"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrchestrator = void 0;
var isClient = typeof window !== 'undefined';
/**
 * Wrapper to get the orchestrator object (typed) from the global window object on the client.
 *
 * @example
 * import { getOrchestrator } from '@bookingcom/web-page-orchestrator';
 *
 * const orchestrator = getOrchestrator();
 *
 * @returns (window as any).orchestrator as Orchestrator | undefined on the client;
 * @returns undefined on the server;
 */
var getOrchestrator = function () {
    if (isClient) {
        return window.orchestrator;
    }
    return undefined;
};
exports.getOrchestrator = getOrchestrator;
